<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Assign Contact Request</v-card-title>

    <v-card-text>

        <m-autocomplete-team-member
            label="Assign To"
            v-model="assign_to"
            :organization_id="organization_id"
        />

        <v-textarea
            label="Message"
            v-model="message"
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            text
            @click="dialog = false;"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!isValid()"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    data() {
        return {
            organization_id: null,
            assign_to: null,
            dialog: false,

            message: '',
        }
    },

    methods: {
        showDialog(contact_request, auto_assign_to) 
        {
            if ( auto_assign_to != null && auto_assign_to == false )
                this.assign_to = null;
            else
                this.assign_to = contact_request.created_by == null ? null : contact_request.created_by.employee_account_id;
            
            this.message = contact_request.message;
            this.organization_id = contact_request.organization_id;

            this.dialog = true;
        },

        isValid()
        {   
            if ( this.assign_to == null ) return false;

            return true;
        },


        onOk() {
            this.dialog = false;

            let assign_info = {
                'new_message' : this.message,
                'assign_to_employee_id' : this.assign_to,
            };

            this.$emit('ok',assign_info);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>